<script lang="ts">
	import { type MailTemplateEntry, mailTemplateEntrySchema } from './MailTemplateConfig.model'
	import Modal from '../../organisms/Modal.svelte'
	import InputField from '../../molecules/InputField.svelte'
	import { setContext } from 'svelte'
	import { type Writable, writable } from 'svelte/store'
	import { closeModal } from 'svelte-modals'
	import { type FormError } from '../../types/formError'
	import { getFormErrors } from '../../utils/formValidation'

	export let entry: MailTemplateEntry
	export let title: string
	export let isOpen: boolean
	export let onAccept: (entry: MailTemplateEntry) => void
	export let acceptText: string

	const formErrors: Writable<FormError[]> = setContext(
		'formErrors',
		writable([{ path: '', message: '' }])
	)

	const DAYS_UNTIL_DELETION = 365

	async function handleAccept() {
		$formErrors = []
		entry.daysUntilDeletion = entry.daysUntilDeletion || DAYS_UNTIL_DELETION // set default value for daysUntilDeletion
		await mailTemplateEntrySchema
			.validate(entry)
			.then(() => {
				onAccept(entry)
				closeModal()
			})
			.catch((err) => {
				$formErrors = getFormErrors(err, '')
			})
	}
</script>

<Modal {title} {isOpen} onAccept={handleAccept} {acceptText}>
	<div class="content" slot="content">
		<InputField bind:value={entry.mailName} label="Mailname" errorPath="mailName" />
		<InputField bind:value={entry.mailTemplateId} label="Templatename" errorPath="mailTemplateId" />
		<InputField
			bind:value={entry.daysUntilDeletion}
			label="Aufbewahrungsfrist (Tage)"
			placeholder={DAYS_UNTIL_DELETION}
			errorPath="daysUntilDeletion"
		/>
	</div>
</Modal>

<style lang="scss">
	@use '$styles/global';

	.content {
		@include global.flex-col(1rem);

		width: 100%;
		margin-top: 1rem;
	}
</style>
